module.exports = "<div class=\"card col-md-10 offset-md-1 col-lg-6 offset-lg-3\">\n    <div class=\"row\">\n        <div class=\"col-md-10 offset-md-1\">\n            <h4 jhiTranslate=\"register.confirmation.title\">Registration</h4>\n            <div class=\"how\" jhiTranslate=\"register.confirmation.how\"></div>\n            <div class=\"how\" jhiTranslate=\"register.confirmation.how2\"></div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/account/register/register-confirmation.component.html
// module id = 379
// module chunks = 0